<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("API_LOCATION_PARAMS")}}
                </div>

                <div class="form-group mt-2" v-for="general_field in general_fields">
                    <label class="form-label" >
                        {{general_field.title}}
                    </label>

                    <div class="input-group flex-nowrap" v-if="!(is_bool_field(general_field))">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input :id="general_field.key" type="text" class="form-control"
                               v-model="location.general_fields[general_field.key]">
                    </div>

                    <div class="input-group flex-nowrap" v-if="is_bool_field(general_field)">
                        <b-form-radio-group
                            :id="'btn-radios-' + general_field.key"
                            v-model="location.general_fields[general_field.key]"
                            button-variant="outline-primary"
                            :options="[
                                  { text: 'YES', value: true },
                                  { text: 'NO', value: false }
                                  ]"
                            :name="'btn-radios-' + general_field.key"
                            buttons
                        ></b-form-radio-group>
                    </div>

                </div>


                <location_general_params :location="location"></location_general_params>

            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import { VueEditor } from "vue2-editor";
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";

export default {
    name: "api_general_tab",

    components : {
        Location_general_params,
        vSelect,
        VueEditor
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
            payments    : [],
            shippings   : [],
            categories  : [],
            restaurants : [],
        }
    },

    methods : {

        is_bool_field(field) {
            if(field.key == 'is_catalog' || field.key == 'show_review') {
                return true;
            }
            return false;
        },



    },
    computed: {

        general_fields() {
            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

    }
}
</script>

<style scoped>

</style>
